import case1Logo from '@/src/assets/images/case-study-logo1.png';
import case2Logo from '@/src/assets/images/case-study-logo2.png';
import case3Logo from '@/src/assets/images/case-study-logo3.png';
import case4Logo from '@/src/assets/images/case-study-logo4.png';
import case5Logo from '@/src/assets/images/case-study-logo5.png';
import case5Details from '@/src/assets/images/case-study-details5.png';

export interface CaseStudy {
  id: number;
  companyName: string;
  category: string;
  summary: string;
  img: string;
  logo: string;
  link: string;
  details: {
    establishment: string;
    trainingPeriod: string;
    businessContent: string;
    businessDetail: string;
    problem: string;
    solution: string;
    interviews: {
      question: string;
      answer: string;
      image?: string;
    }[];
  };
}

export const allCaseStudies: CaseStudy[] = [
  {
    id: 1,
    companyName: "株式会社油研",
    category: "環境・廃棄物リサイクル業",
    summary: "研修から社内での積極的AI導入が増幅。<br>原因特定が難しい業務もAIにて、即座に解決。",
    img: case1Logo,
    logo: case1Logo,
    link: "/case-study/1",
    details: {
      establishment: "1977年3月18日",
      trainingPeriod: "2025年11月〜2025年12月",
      businessContent: "環境・廃棄物リサイクル業",
      businessDetail: "・環境保護関連業務全般<br>・収集運搬<br>・リサイクル提案",
      problem: "どの業務に、どう使うべきか具体的なイメージが湧かず、 ITリテラシーが高い層のみの利用に留まっていた。",
      solution: "これまで人の手で行っていた単純作業をAIに代替。作業時間を大幅に短縮でき、工数削減に成功した。",
      interviews: [
        {
          question: "生成AI導入研修の受講にはどんな背景がありましたか？",
          answer: "個人単位での生成AIを使用する事はありましたが、業務での活用に関しては、行っておりませんでした。<br>また、ニュースなどでの機密情報の取扱いについてなどの懸念もあり積極的な業務への活用を躊躇することがありました。"
        },
        {
          question: "生成AI導入研修を実際に受けてみていかがでしたか？",
          answer: "有名どころの生成AIツール以外にも、特定の分野に特化したものがあり、多くが無料の範囲で十分活用できることを社内でも共有できました。<br>文章の作成やその校正、文字ベースの情報を視覚的に編集したりなど、人の手だけで行うには時間がかかりすぎる内容を、生成AIを活用し、実行しています。<br>直近での事例として、社内のパソコンの入れ替え作業があったのですが、その設定時のエラーについて、その画面の写真を送るだけで、適した解決法がわかりました"
        },
        {
          question: "今後の展開を教えてください。",
          answer: "受講後の数か月でも新しいツールについての情報が出てきており、使用すべきツールも変わっていっています。社内のシステムにも組み合わせながら、活用を進めていきます。"
        }
      ]
    }
  },
  {
    id: 2,
    companyName: "株式会社HAL",
    category: "通信販売事業",
    summary: "生成AI研修で「作業」から「思考」へ。<br>プロンプト習得で定型業務の自動化とDXを加速。",
    img: case2Logo,
    logo: case2Logo,
    link: "/case-study/2",
    details: {
      establishment: "2018年1月23日",
      trainingPeriod: "2025年8月〜2025年9月",
      businessContent: "通信販売事業",
      businessDetail: "・通信販売事業",
      problem: "定型業務やデータ整理にリソースが奪われ、戦略的分析が不足。独学ではプロンプトのコツが掴めず、AI活用の限界を感じていた。",
      solution: "AIの特性理解により、適切な指示出しで単純作業や下書き作成を高速化。生産性が向上し、現場主導でAIを使いこなす文化が醸成。",
      interviews: [
        {
          question: "生成AI導入研修の受講にはどんな背景がありましたか？",
          answer: "定型業務やデータ整理などの「作業的タスク」に時間を奪われ、本来注力すべき戦略的思考や深い分析にリソースを割けていないことが課題でした。<br>また、独学で生成AIを触ってはいたものの、適切なプロンプトが分からず、期待した回答が得られないといった「使いこなしの限界」を感じていました。"
        },
        {
          question: "生成AI導入研修を実際に受けてみていかがでしたか？",
          answer: "AIの特性や仕組みを正しく理解したことで、「AIが得意なこと・不得意なこと」の切り分けができるようになりました。<br>具体的には、指示の出し方を工夫することで単純作業の自動化や叩き台作成のスピードが格段に向上し、目に見えて生産性が高まったと実感しています。"
        },
        {
          question: "今後の展開を教えてください。",
          answer: "既に実現した効率化をベースに、次はお客様対応や各専門業務へのAI導入を具体化させたいです。<br>現場レベルでAIを使いこなす文化を定着させ、組織全体のDXを底上げすることを目指します。"
        }
      ]
    }
  },
  {
    id: 3,
    companyName: "株式会社selector",
    category: "商品開発事業",
    summary: "生成AI研修で資料作成を効率化。<br>属人化を解消し、LPや広告制作の高速化で成果最大化へ。",
    img: case3Logo,
    logo: case3Logo,
    link: "/case-study/3",
    details: {
      establishment: "2017年7月7日",
      trainingPeriod: "2025年10月〜2025年11月",
      businessContent: "商品開発事業",
      businessDetail: "・ECサイト構築<br>・ECサイト運営<br>・商品開発事業",
      problem: "生成AIが業務に浸透せず、資料作成や情報整理の属人化と作業時間の増大が課題に。業務効率化と品質の底上げが急務だった。",
      solution: "AI活用によりマニュアルや資料作成を短時間化。作業効率と品質が安定し、今後は広告制作やABテストの高速化による成果向上を見込む。",
      interviews: [
        {
          question: "生成AI導入研修の受講にはどんな背景がありましたか？",
          answer: "社内で生成AIを業務活用できておらず、資料作成や情報整理などの作業に時間がかかっていました。<br>属人化も課題だったため、AIを活用して業務効率と品質を高めたいと考え受講しました。"
        },
        {
          question: "生成AI導入研修を実際に受けてみていかがでしたか？",
          answer: "研修後は生成AIを活用できるようになり、マニュアル作成や資料作成が短時間で行えるようになりました。<br>作業効率が上がり、アウトプットの質も安定してきたと感じています。"
        },
        {
          question: "今後の展開を教えてください。",
          answer: "今後は生成AIを本格的に活用し、LPの改善・新規作成から広告用の画像・動画制作までスピードを上げていきます。<br>複数案を高速でABテストし、勝ちパターンを量産して成果を最大化します。"
        }
      ]
    }
  },
  {
    id: 4,
    companyName: "株式会社ITS",
    category: "コンサルティング業",
    summary: "BPO業務の標準化を生成AIで加速。<br>属人化を解消し、判断業務への集中で品質向上を実現。",
    img: case4Logo,
    logo: case4Logo,
    link: "/case-study/4",
    details: {
      establishment: "2025年4月1日",
      trainingPeriod: "2025年8月〜2025年9月",
      businessContent: "コンサルティング業",
      businessDetail: "・バックオフィスのBPO受託業務<br>・経営サポート業務<br>・コンサルティング業務<br>・M&Aアドバイザリー業務<br>・EC運営受託業務",
      problem: "事務や問い合わせ対応の工数増大に加え、業務の属人化や品質のバラつきが課題。新人教育や引き継ぎのコスト削減を課題としていた。",
      solution: "AIを判断支援ツールとして活用し、資料作成や手順整理を効率化。ゼロから考える時間を減らし、付加価値の高い業務への集中を実現。",
      interviews: [
        {
          question: "生成AI導入研修の受講にはどんな背景がありましたか？",
          answer: "BPO業務では、定型的な事務作業や問い合わせ対応、資料作成などに多くの工数がかかっており、業務量の増減に対して人手での調整が必要になる点が課題でした。<br>また、<br>・属人化しやすい業務がある<br>・担当者ごとにアウトプットの品質にばらつきが出やすい<br>・新人教育や引き継ぎに時間を要する<br>といった点もあり、業務効率化と品質の標準化を同時に進める手段として、生成AIの活用を検討するようになったことが背景です。"
        },
        {
          question: "生成AI導入研修を実際に受けてみていかがでしたか？",
          answer: "研修を通じて、生成AIは単なる文章生成ツールではなく、BPO業務における「業務補助・判断支援ツール」として活用できることを具体的に理解できました。<br>特に、<br>・メール文面や報告書のドラフト作成<br>・マニュアル、FAQのたたき作成<br>・業務手順の整理、言語化<br>・確認事項や抜け漏れ防止のチェック<br>といった領域で、作業時間の短縮だけでなく、アウトプットの品質が安定する効果を実感しています。<br>「ゼロから考える時間」が減り、人は確認・判断・調整といった付加価値の高い業務に集中できる点が大きな導入効果だと感じました。"
        },
        {
          question: "今後の展開を教えてください。",
          answer: "今後は、生成AIを個人の便利ツールとしてではなく、BPO業務全体の生産性を高める仕組みとして活用していきたいと考えています。<br>具体的には、<br>・定型業務の一次対応、下書き作成への活用<br>・業務マニュアルやナレッジの整備、更新の効率化<br>・業務引き継ぎや教育コストの削減<br>・業務フロー改善の検討材料としての活用<br>などを進め、業務の標準化・再現性の高いBPO体制構築につなげていく予定です。<br>最終的には、品質を維持・向上させながら、より柔軟で持続可能なBPO運用を実現していきたいと考えています。"
        }
      ]
    }
  },
  {
    id: 5,
    companyName: "Growthix Capital 株式会社",
    category: "M&A仲介事業",
    summary: "生成AI研修で組織の意識が激変。<br>最新AIツールの習得で少人数でも最大価値を創出。",
    img: case5Logo,
    logo: case5Logo,
    link: "/case-study/5",
    details: {
      establishment: "2019年5月7日",
      trainingPeriod: "2025年9月〜2025年10月",
      businessContent: "M&A仲介事業",
      businessDetail: "・企業統合（PMI）支援<br>・資本提携（M&A）支援",
      problem: "AI活用の必要性を感じつつも、具体的な活用イメージや学習環境が不足。スキルの個人差と属人化が組織全体の課題となっていた。",
      solution: "最新ツールの体系的理解により、市場調査等の自動化を実感。自発的な活用文化が根付き、少数精鋭で成果を出す体制構築へ加速。",
      interviews: [
        {
          question: "生成AI導入研修の受講にはどんな背景がありましたか？",
          answer: "急速にAI活用が叫ばれる中、社内では『AIが今後の業務に不可欠になる』という共通認識はありましたが、実態としては具体的な活用イメージが湧かず、何から着手すべきか分からないという漠然とした課題を抱えていました。<br>事実、社内でAIを実務に取り入れているのは数名に留まり、属人的な活用に終わっていました。一方で、他の社員からは『興味はあるが、使いこなせるか不安』『どこで学べば正解なのか』という声が多く上がっており、個人の意欲に対して学習環境が整っていない状況でした。<br>こうした『スキルの個人差』と『学習リソースの不足』を解消し、組織全体として一歩踏み出すためのきっかけとして、今回の生成AI導入研修の受講を決定いたしました。"
        },
        {
          question: "生成AI導入研修を実際に受けてみていかがでしたか？",
          answer: "研修を通じて、AIの種類ごとの特性や具体的な活用シーン、即実践可能な投入事例まで体系的に学ぶことができ、受講者からは極めて高い満足度が得られました。<br>具体的には、『ChatGPT』や『Gemini』におけるプロンプトの構成力（指示の出し方）が回答の質を左右するという本質的な理解に加え、『Manna（マナス）』や『Genspark』といったAIエージェントの活用により、資料作成から市場調査まで網羅的に自動化できる可能性を実感しました。これまでの認識を覆すようなツールの多機能さには、多くの社員から『目からうろこが落ちた』との驚きの声が上がっています。<br>現在では、日々のルーティーンワークにAIを組み込む社員が急増しており、『AIへの関心』が『自発的な学びと業務効率化』へと明確に転換されたことが、本研修の最大の収穫となりました。",
          image: case5Details
        },
        {
          question: "今後の展開を教えてください。",
          answer: "今回の研修で得た熱量を一過性のものにせず、『AI活用が当たり前の組織文化』を確立することを目指します。今回の学びは、私たちの業務効率を劇的に向上させる確かなきっかけとなりました。<br>AI技術は日々加速度的に進化しており、常に学び続け、アップデートを止めない姿勢こそが、これからの時代を生き抜く鍵だと確信しています。<br>私たちは、『少人数組織こそ、AIを最大限に活用すべきである』と考えています。最新ツールを自在に操ることで、少数精鋭であっても、大規模な組織に引けを取らない、あるいはそれ以上の価値を創出できる環境づくりに邁進してまいります。AIという強力なパートナーと共に、組織としての可能性を無限に広げていく所存です。"
        }
      ]
    }
  }
];